var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-content"},[_c('swiper',{attrs:{"type":6}}),_c('idea'),_c('offer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }